import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../cart";
import { currency, placeholderImg } from "../shared";

/**********************
 * Cart Page (unchanged visually; shows metal if present)
 *********************/
function CartPage() {
  const { state, setQty, removeFromCart, clearCart } = useCart();
  const items = Object.entries(state.items);
  const subtotal = items.reduce(
    (sum, [key, it]) => sum + it.unitPrice * it.qty,
    0,
  );
  const total = subtotal;

  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Your Cart</h1>
      {!items.length ? (
        <p className="jh-sub">Your cart is empty.</p>
      ) : (
        <>
          <ul className="jh-cart-list">
            {items.map(([key, it]) => (
              <li key={key} className="jh-cart-item">
                <img
                  className="jh-cart-img"
                  src={it.image || placeholderImg}
                  alt={it.name}
                  onError={(e) => {
                    e.currentTarget.src = placeholderImg;
                  }}
                />
                <div className="jh-cart-main">
                  <div className="jh-cart-name">{it.name}</div>
                  {it.metal && (
                    <div className="jh-cart-meta">Metal: {it.metal}</div>
                  )}
                  {it.stoneType && (
                    <div className="jh-cart-meta">Stone: {it.stoneType}</div>
                  )}
                  {it.size != null && (
                    <div className="jh-cart-meta">Size: {it.size}</div>
                  )}
                  <div className="jh-cart-price">{currency(it.unitPrice)}</div>
                </div>
                <div className="jh-cart-qty">
                  <label htmlFor={`qty-${key}`} className="jh-label">
                    Qty
                  </label>
                  <input
                    id={`qty-${key}`}
                    className="jh-input"
                    type="number"
                    min={0}
                    value={it.qty}
                    onChange={(e) =>
                      setQty(key, Math.max(0, Number(e.target.value) || 0))
                    }
                  />
                </div>
                <button
                  className="jh-link danger"
                  onClick={() => removeFromCart(key)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>

          <div className="jh-cart-summary">
            <div className="jh-cart-row">
              <span>Subtotal</span>
              <strong>{currency(subtotal)}</strong>
            </div>
            <div className="jh-cart-row total">
              <span>Total</span>
              <strong>{currency(total)}</strong>
            </div>
            <div className="jh-cart-row small">
              Exact tax, shipping, and discounts are shown at checkout.
            </div>
            <div className="jh-actions">
              <Link to="/checkout" className="jh-btn">
                Checkout
              </Link>
              <button className="jh-btn jh-btn--ghost" onClick={clearCart}>
                Clear cart
              </button>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default CartPage;
